import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { pluck } from 'rxjs/operators';

import { AppConfig } from '../../../app.settings';
import { Machine } from '../../models/entities/machine.type';
import { UpdateLocationInterface } from '../../interfaces/update-location.interface';
import { Monitor } from '../../models/entities/monitor.type';

@Injectable()
export class MachinesService {
  private endpoint: string;

  constructor(
    private readonly http: HttpClient,
    private readonly config: AppConfig
  ) {
    this.endpoint = `${this.config.getConfig('api')}Machine`;
  }

  assignToCategory(machineAddresses: string[], categoryId: number): Observable<void> {
    return this.http.post<void>(`${this.endpoint}/AssignToCategory`, { machineAddresses, categoryId });
  }

  getMachines(): Observable<Machine[]> {
    return this.http.get<Machine[]>(this.endpoint);
  }

  updateShowPrimaryFlag(physicalAddresses: string[], showPrimaryValue: boolean) {
    const body = {
      MachinePhysicalAddresses: physicalAddresses,
      ShowPrimary: showPrimaryValue,
    };
    return this.http.post(
      `${this.endpoint}/UpdateMachineShowPrimaryFlag`,
      body
    );
  }

  setUserLocation(location: UpdateLocationInterface) {
    return this.http.post(`${this.endpoint}/SetUserLocation`, location);
  }

  getUserLocation(userId: string): Observable<Machine[]> {
    return this.http.get<Machine[]>(`${this.endpoint}/UserLocation/${userId}`);
  }

  stopAllPlaylistsOnMachine(physicalAddress: string): Observable<void> {
    return this.http.get<void>(`${this.endpoint}/Stop-all-playlists-on-machine/${physicalAddress}`);
  }

  showImageInSnapshot(physicalAddress: string[], isToShowImage: boolean): Observable<void> {
    const params = new HttpParams().set('isToShowImage', isToShowImage);
    return this.http.post<void>(`${this.endpoint}/show-image-in-snapshot`, physicalAddress, { params });
  }

  getLocationMonitors(macAddress: string): Observable<Monitor[]> {
    return this.http
      .get(`${this.endpoint}/GetSynchDataAsync/${macAddress}`)
      .pipe(pluck('MonitorProfiles'));
  }

  getActiveWindows(physicalAddress: string): Observable<void> {
    const params: HttpParams = new HttpParams().set('physicalAddress', physicalAddress);
    return this.http.get<void>(`${this.endpoint}/active-windows`, { params });
  }

  public getLocationNameByPhysicalAddress(physicalAddress: string): Observable<string> {
    return this.http.get<string>(`${this.endpoint}/location-name/${physicalAddress}`);
  }
}
